import React from 'react';
import { Button } from '@/components/ui/button';

interface CreateInvoiceFooterProps {
  activeStep: number;
  onPrevClick: () => void;
  onNextClick: () => void;
  isDraft?: boolean;
  onSaveDraft?: () => void;
  loading?: boolean;
}

const CreateInvoiceFooter: React.FC<CreateInvoiceFooterProps> = ({
  activeStep,
  onPrevClick,
  onNextClick,
  isDraft = false,
  onSaveDraft,
  loading = false
}) => {
  const isFirstStep = activeStep === 1;
  const isLastStep = activeStep === 3;

  return (
    <footer className="flex justify-end gap-4">
      {/* {isDraft && (
        <Button
          variant="primary-reverse"
          className="font-semibold text-base rounded-[24px] h-[44px] w-[120px]"
          onClick={onSaveDraft}
        >
          Save Draft
        </Button>
      )} */}

      <Button disabled={loading} variant="text" className="text-[#E8507E] font-semibold text-lg" onClick={onPrevClick}>
        {isFirstStep ? 'Cancel' : 'Previous'}
      </Button>

      <Button
        className="font-semibold text-base rounded-[24px] h-[44px] w-[87px]"
        onClick={onNextClick}
        disabled={loading}
      >
        {isLastStep ? 'Finish' : 'Next'}
      </Button>
    </footer>
  );
};

export default CreateInvoiceFooter;
